import React from 'react';
import { 
  ShieldAlert, 
  TrendingUp, 
  AlertTriangle, 
  ExternalLink, 
  Radio,
  BellRing
} from 'lucide-react';

export const ThreatIntelPage: React.FC = () => {
  const trends = [
    { title: 'Toll Road SMS Impersonation (Linkt)', increase: '+142%', risk: 'CRITICAL', note: 'Deceptive SMS claiming unpaid tolls of $6.80 targeting NSW and VIC motorists.' },
    { title: 'Fake myGov Tax Refund Phishing', increase: '+88%', risk: 'HIGH', note: 'Post-tax season lures offering $800-$2,400 refunds requiring credit card submission.' },
    { title: 'Facebook Marketplace PayID Upgrade Traps', increase: '+64%', risk: 'HIGH', note: 'Deceptive emails pretending to be Commonwealth Bank demanding upgrade deposits.' }
  ];

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-8">
      <div className="text-center space-y-2">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-950 text-blue-300 text-xs font-bold border border-blue-800">
          <ShieldAlert className="w-3.5 h-3.5" />
          <span>AUSTRALIAN THREAT INTELLIGENCE SYNDICATION</span>
        </div>
        <h1 className="text-3xl font-extrabold text-white">Australian Cyber Threat & Scamwatch Digest</h1>
        <p className="text-xs text-slate-400 max-w-xl mx-auto">
          Weekly intelligence aggregated from ACMA, Scamwatch, ACSC Cyber.gov.au, and banking security incident desks.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-xs">
        {trends.map((t, idx) => (
          <div key={idx} className="p-6 rounded-3xl bg-slate-900 border border-slate-800 space-y-3 shadow-xl">
            <div className="flex items-center justify-between">
              <span className="text-rose-400 font-bold font-mono">{t.increase} This Month</span>
              <span className="px-2 py-0.5 rounded text-[10px] bg-rose-950 text-rose-300 font-bold border border-rose-800">{t.risk}</span>
            </div>
            <h3 className="font-bold text-white text-sm">{t.title}</h3>
            <p className="text-slate-400 leading-relaxed">{t.note}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
